import { useNavigationContext } from '3-foundation/Navigation/NavigationContext';
import { UI_Logo } from 'ui/components/2-molecules/Logo/Logo';
import { UI_Header } from 'ui/components/4-habitats/Header/Header';
import { usePageContext } from '3-foundation/PageContent/PageContext';
import { LanguageSelector } from '2-feature/Navgation/LanguageSelector';
import { useEffect, useReducer } from 'react';
import { useRouter } from 'next/router';
import { useSiteContext } from '3-foundation/Site/SiteContext';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { CludoComment } from 'ui/components/10-vendors/cludo/CludoComment';

interface LogoProps {
	desktopLogo?: { url: string };
	mobileLogo?: { url: string };
}

export const Header = ({ desktopLogo, mobileLogo }: LogoProps) => {
	const navContext = useNavigationContext();
	const pageContext = usePageContext();
	const siteContext = useSiteContext() ?? {};
	const router = useRouter();
	const dictionary = useDictionaryContext();

	const root = navContext?.getNavigation({
		currentUrl: pageContext.path,
		includeRootItem: true,
	});

	const { searchSettings } = siteContext?.settings ?? {};

	// Calling this reducer sends a signal (random number) to the UI which closes the navigation panel
	// The same signal is used to close all navigation items in the navigation
	const [resetNavStateSignal, resetNavState] = useReducer(() => {
		return Math.random();
	}, 0);

	// When ever the route changes we call resetNavState to close the navigation panel
	// and to close all navigation items
	useEffect(() => {
		const handleRouteChange = () => {
			resetNavState();
		};

		router.events.on('routeChangeComplete', handleRouteChange);

		return () => {
			router.events.off('routeChangeComplete', handleRouteChange);
		};
	}, [router]);

	const rootNode = root?.[0];

	const homePageLinkLabel = siteContext?.homePageLinkLabel;

	const homePage: Navigation.NavigationItem = {
		id: rootNode?.id,
		name: rootNode?.name,
		url: rootNode?.url,
		descendants: null,
		title: homePageLinkLabel,
	};

	return (
		<>
			<CludoComment>
				<UI_Header
					heading={siteContext.title}
					logoArea={<UI_Logo heading={siteContext.title} desktopLogo={desktopLogo} mobileLogo={mobileLogo ? mobileLogo : desktopLogo} />}
					languageSelector={<LanguageSelector />}
					navigationItems={[...(homePageLinkLabel ? [homePage] : []), ...(rootNode?.descendants ? rootNode.descendants : [])]}
					maxLevels={2}
					style="primary"
					serviceNavigationItems={siteContext?.serviceMenu ?? []}
					reset={resetNavStateSignal}
					skipToMain={{ text: dictionary.getAction('SkipToMain'), explainerText: dictionary.getExplainer('SkipToMain') }}
					toggleMenuLabel={dictionary.getAction('ToggleMenu')}
					search={{ url: searchSettings?.searchUrl, text: dictionary.getSearch('BtnSearch') }}
				/>
			</CludoComment>
		</>
	);
};
